import { BrowserRouter, Routes, Route } from 'react-router-dom';

import './App.css';
import Home from './components/home/home';

function App() {
  return (
    <div className="App">
      <header className="App-body">
        <BrowserRouter>
          <Routes>
            <Route path="*" element={<Home />} />
          </Routes>
        </BrowserRouter>
      </header>
    </div>
  );
}

export default App;
